import { useState } from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { BookMark, GoogleIcon } from "../components/icons";
import { StaticBookIllustration } from "../components/StaticBookIllustration";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function SignIn() {
  const { t } = useTranslation();
  const [agreed, setAgreed] = useState(false);
  const loginError = new URLSearchParams(window.location.search).get("login");

  return (
    <div className="tp-app">
      <div
        className="tp-screen"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          paddingTop: 36,
          paddingBottom: 32,
        }}
      >
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <LanguageSwitcher />
      </div>
      <div style={{ textAlign: "center" }}>
        <div style={{ display: "inline-block", marginBottom: 12 }}>
          <BookMark />
        </div>
        <div className="tp-display" style={{ marginBottom: 8 }}>
          {t("appName")}
        </div>
        <div className="tp-body" style={{ fontSize: 17, lineHeight: 1.4, color: "var(--tp-ink-soft)", padding: "0 14px" }}>
          {t("signIn.tagline")}
        </div>
        {loginError === "not_invited" && (
          <div className="tp-error" role="alert" style={{ marginTop: 12 }}>{t("signIn.notInvited")}</div>
        )}
        {loginError === "failed" && (
          <div className="tp-error" role="alert" style={{ marginTop: 12 }}>{t("signIn.loginFailed")}</div>
        )}
      </div>

      <StaticBookIllustration />

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <label
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            padding: "10px 14px",
            cursor: "pointer",
            fontSize: 14,
            lineHeight: 1.4,
            color: "var(--tp-ink)",
          }}
        >
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            style={{
              width: 20,
              height: 20,
              marginTop: 1,
              flex: "0 0 auto",
              accentColor: "var(--tp-accent)",
              cursor: "pointer",
            }}
          />
          <span>
            <Trans
              i18nKey="signIn.agreement"
              components={{
                terms: <Link to="/legal" style={{ color: "var(--tp-accent)", textDecoration: "underline" }} />,
                privacy: <Link to="/legal" style={{ color: "var(--tp-accent)", textDecoration: "underline" }} />,
              }}
            />
          </span>
        </label>

        {agreed ? (
          <a className="tp-btn tp-btn-primary tp-btn-block" href="/auth/google">
            <GoogleIcon /> {t("signIn.continueWithGoogle")}
          </a>
        ) : (
          <button
            type="button"
            className="tp-btn tp-btn-primary tp-btn-block"
            disabled
            aria-disabled="true"
          >
            <GoogleIcon /> {t("signIn.continueWithGoogle")}
          </button>
        )}
        <div className="tp-body" style={{ textAlign: "center", fontSize: 13, color: "var(--tp-ink-soft)", padding: "0 14px" }}>
          {t("signIn.footer")}
        </div>
      </div>
      </div>
    </div>
  );
}
